import LazyLoad from "vanilla-lazyload";


const Common = {
  lazyLoadInstance: null,

  init() {
    this.lazyLoadInstance = new LazyLoad();

    Common.events();
    Common.tabs();
    Common.counterAnimation();
  },

  events() {
    // SEO
    $(".seo-read-more").on("click", function (e) {
      $(this).parent().find(".content-hidden").toggleClass("show");
    });

    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Video.
    $(".js-play-video").on("click", function () {
      $(this).closest(".video").addClass("playing").find("video")[0].play();
    });

    $(".video__overlay").on("click", function () {
      $(this).parent().toggleClass("playing").find("video")[0].pause();
    });

    // Accordion
    $(".accordion").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

    // SEO
    $(".seo__more-btn").on("click", function () {
      let content = document.getElementsByClassName("seo__content-2")[0];
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      let text = $(this).children()[0].innerText;

      if (text == "LASĪT VAIRĀK") {
        $(this).children("span").text("Lasīt mazāk");
      } else {
        $(this).children("span").text("Lasīt vairāk");
      }

      $(this).toggleClass("active");
    });
  },

  /**
   * Tabs
   */
  tabs() {
    // Show first
    $("[data-tabs] [data-container]").not(":first-child").hide();
    $("[data-tabs] [data-target]").first().addClass("active");

    $("[data-target]").on("click", function () {
      const btnEl = $(this);
      const tabEl = btnEl.closest("[data-tabs]");

      const targetTab = btnEl.data("target");

      btnEl.parent().siblings().children().removeClass("active");
      btnEl.addClass("active");

      tabEl.find("[data-container]").hide();
      tabEl.find(`[data-container="${targetTab}"]`).show();
    });

    $('[data-target="1"]').addClass("active");
  },

  counterAnimation() {
    function animateCounter(el, duration = 2000) {
      const target = +el.dataset.target;
      const startTime = performance.now();

      // Auto step adjustment: divide into about 60 steps
      const minSteps = 60;
      const stepValue = Math.max(1, Math.floor(target / minSteps));

      function update(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1); // 0 to 1

        // Use easing (easeOutQuad)
        const easedProgress = 1 - (1 - progress) * (1 - progress);

        let currentValue = Math.floor(easedProgress * target);

        // Round to nearest step
        currentValue = Math.round(currentValue / stepValue) * stepValue;

        el.textContent = currentValue.toLocaleString(); // format with commas

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          el.textContent = target.toLocaleString(); // Final correction
        }
      }

      requestAnimationFrame(update);
    }

    const counters = document.querySelectorAll('.counter');

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.6
    });

    counters.forEach(counter => observer.observe(counter));
  },


};

export default Common;
